export default "__VITE_ASSET__DxY_RjRU__"